"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAttributesFullSchema = void 0;
const zod_1 = require("zod");
const address_1 = require("./address");
const customer_1 = require("./customer");
const invoice_full_1 = require("./invoice_full");
const order_1 = require("./order");
const order_item_full_1 = require("./order_item_full");
exports.OrderAttributesFullSchema = order_1.OrderAttributesSchema.merge(zod_1.z.object({
    OrderItems: zod_1.z.array(order_item_full_1.OrderItemAttributesFullSchema).nullable().optional(),
    Customer: customer_1.CustomerAttributesFullSchema.nullable().optional(),
    Invoices: zod_1.z.array(invoice_full_1.InvoiceAttributesFullSchema).nullable().optional(),
    DeliveryAddress: address_1.AddressAttributesSchema.nullable().optional(),
    PickupAddress: address_1.AddressAttributesSchema.nullable().optional(),
}));
//# sourceMappingURL=order_full.js.map